// extracted by mini-css-extract-plugin
export default {"result-button-content":"ResultsButton_result-button-content__2r-L9","result-button":"ResultsButton_result-button__-uqhM"};